// @flow

export const PHYSICAL_INSURANT_PERSON = 'PhysicalInsurantPerson';
export const JURIDICAL_INSURANT_PERSON = 'JuridicalInsurantPerson';

export const DMS_INSURED = 'DmsInsured';
export const DMS_ADMIN = 'DmsAdmin';
export const DMS_SUPERVISOR = 'DmsSupervisor';
export const DMS_HR = 'DmsHr';

export const CUSTOMER_OSGOP_OSOPO = 'CustomerOsgopOsopo'; // 37 Сотрудник клиента ОСОПО/ОСГОП
export const BKS_OSOPO_OSGOP = 'BksEmployeeOsgopOsopo';
export const BKS_EMPLOYEE = 'BksEmployee';// 24 Сотрудник БКС
export const BKS_ACCEPTING_EMPLOYEE = 'BksAcceptingEmployee'; // 25 Акцептующий сотрудник БКС
export const MASS_LOAD_CUSTOMER = 'MassLoadCustomer'; // 26 Клиент массовой загрузки
export const MASS_LOAD_ACCOUNT_CUSTOMER = 'MassLoadAccountCustomer'; // 27 Клиент-аккаунт массовой загрузки
export const MASS_LOAD_POLICY_CANCELLATION = 'MassLoadPolicyCancellation'; // роль с возможностью аннулирования полисов


export const COMPANY_SUPERMANAGER = 'CompanySupermanager';
export const COMPANY_ACCOUNT_MANAGER = 'CompanyAccountManager'; // 22 Аккаунт-менеджер
export const COMPANY_MANAGER = 'CompanyManager'; // 18 Персональный менеджер страхователя ЮЛ
export const COMPANY_CLIENT_MANAGER = 'CompanyClientManager';
export const COMPANY_SUPERVISOR = 'CompanySupervisor'; // 19 Супервайзер корпоративного договора
export const COMPANY_ADMIN = 'CompanyAdmin'; // 20 Администратор полиса корпоративного договора
export const COMPANY_DRIVER = 'CompanyDriver'; // 21 Водитель-Заявителыь по полису корпоративного договора
export const COMPANY_UNCONFIRMED_EMPLOYEE = 'CompanyUnconfirmedEmployee';
export const COMPANY_AGENT_MANAGER = 'CompanyClientAgentManager'; // редактирование агентов-делегатов в страхователе
export const COMPANY_SUB_AGENT_MANAGER = 'CompanyClientSubAgentManager'; // работа с агентами-привлеченцами


export const COMPANY_CLIENT_ROLES =	[
	COMPANY_UNCONFIRMED_EMPLOYEE,
	COMPANY_SUPERMANAGER,
	COMPANY_ACCOUNT_MANAGER,
	COMPANY_MANAGER,
	COMPANY_CLIENT_MANAGER,
	COMPANY_SUPERVISOR,
	COMPANY_ADMIN,
	COMPANY_DRIVER,
];



